import { atom } from 'jotai';

/**
 * Single open SidePanel coordinator.
 *
 * Each `SidePanel`-based drawer in the structuring module uses
 * `useExclusiveDrawer(key, open, onClose)` to claim this slot when it opens.
 * If a different drawer claims the slot while we're open, our `onClose` fires
 * — guaranteeing only one drawer is rendered at a time.
 */
export const activeDrawerAtom = atom<string | null>(null);
